import { FC_MWEB } from "@ctv/core/feature-control/constants";
import { useContentResource } from "@ctv/core/resource";
import { useFeatureControl } from "@ctv/shared-core/src";
import { FLAGGED_USER_ERROR_BASE64 } from "@ctv/shared-core/src/assets/error";
import BMView from "@ctv/shared-core/src/components/View/BMView";
import { Footer, Header } from "@ctv/shared/components/Layout";
import { BMPrimitives, BMText } from "@traveloka/district-bloom";
import { Dimensions, Image, Pressable, StyleSheet } from "react-native";
import { useAuth } from "../CognitoAuthContext";

const MAX_MOBILE_WIDTH = 480;
const IMAGE_WIDTH = 113;
const IMAGE_HEIGHT = 120;

const { width: screenWidth } = Dimensions.get("screen");

export default function FlaggedUserError() {
  const auth = useAuth();
  const { CorporateFlaggedUserErrorMessage: cr } = useContentResource();

  const { enabled: mwebEnabled } = useFeatureControl(FC_MWEB);
  const isMobile = screenWidth < MAX_MOBILE_WIDTH && mwebEnabled;

  return (
    <BMView flex>
      {!isMobile && <Header />}
      <BMView
        style={{ marginHorizontal: BMPrimitives.BMSize.sm }}
        flex
        align="center"
        justify="center"
      >
        <Image
          source={{ uri: FLAGGED_USER_ERROR_BASE64 }}
          style={styles.image}
        />
        <BMView justify="center" align="center" spacing="lg">
          <BMText
            style={[styles.title, styles.textAlignCenter]}
            variant="titleSmall"
            ink="BMStyleTextInkPrimary"
          >
            {cr.errorTitle}
          </BMText>
          <BMView>
            <BMText
              style={styles.textAlignCenter}
              variant="paragraphNormal"
              ink="BMStyleTextInkPrimary"
            >
              {cr.errorDescription}
            </BMText>
            <BMText
              style={styles.textAlignCenter}
              variant="paragraphNormalEm"
              ink="BMStyleTextInkPrimary"
            >
              {auth.user?.email}.
            </BMText>
            <BMText
              style={styles.textAlignCenter}
              variant="paragraphNormal"
              ink="BMStyleTextInkPrimary"
            >
              {cr.contactAccountManager}
            </BMText>
          </BMView>
          <Pressable onPress={() => auth.logout()}>
            <BMText variant="paragraphLargeEm" ink="BMStyleTextInkAction">
              {cr.cta}
            </BMText>
          </Pressable>
        </BMView>
      </BMView>
      {!isMobile && <Footer />}
    </BMView>
  );
}

const styles = StyleSheet.create({
  image: { width: IMAGE_WIDTH, height: IMAGE_HEIGHT },
  title: {
    marginTop: BMPrimitives.BMSize.xl2,
  },
  textAlignCenter: {
    textAlign: "center",
  },
});
